"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.query = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.query = (0, graphql_tag_1.default) `
  query FanMotorProModulateQuery($inputs: [FanMotorProInputType!]!) {
    user {
      fanMotorProModulate(input: $inputs) {     
        errors {
          code
          text
        }
        warnings {
          code
          text
        }
        fanShaftMechanicalEfficiency
        fanShaftStaticEfficiency
        fanSpeed
        maximumFanSpeed
        staticPressure
        totalPressure
        velocityPressure
        systemEffectPressureDrop
        shaftPower
        outletVelocity  
        gridPower
        drivePower
        motorPowerAtSpeed
        motorSpeed
        maximumMotorSpeed
        motorFrequency
        maximumMotorFrequency
        current
        fanDriveMotorMechanicalEfficiency
        fanDriveMotorStaticEfficiency
      }
    }
  }
`;
//# sourceMappingURL=queries.js.map